import React from 'react'
import Marquee from './Marquee'
import { cn } from "@/lib/utils";


const bannerMarqueeImg1 = [
    {
        name: "Ludo1",
        img: "../img/gamepic/14.Ludo1.png",
    },
    {
        name: "Ludo2",
        img: "../img/gamepic/14.Ludo2.png",
    },
    {
        name: "Ludo3",
        img: "../img/gamepic/14.Ludo3.png",
    },
    {
        name: "Ludo4",
        img: "../img/gamepic/14.Ludo4.png",
    },
]


const reviews = [
    {
        name: "Jack",
        username: "@jack",
        body: "I've never seen anything like this before. It's amazing. I love it.",
        img: "https://avatar.vercel.sh/jack",
    },
    {
        name: "Jill",
        username: "@jill",
        body: "I don't know what to say. I'm speechless. This is amazing.",
        img: "https://avatar.vercel.sh/jill",
    },
    {
        name: "John",
        username: "@john",
        body: "I'm at a loss for words. This is amazing. I love it.",
        img: "https://avatar.vercel.sh/john",
    },
    {
        name: "Jill1",
        username: "@jill1",
        body: "I don't know what to say. I'm speechless. This is amazing.",
        img: "https://avatar.vercel.sh/jill",
    },
    {
        name: "John2",
        username: "@john2",
        body: "I'm at a loss for words. This is amazing. I love it.",
        img: "https://avatar.vercel.sh/john",
    },
];

const firstRow = reviews.slice(0, reviews.length / 2);
const secondRow = reviews.slice(reviews.length / 2);


const MarqueeImg = ({
    img,
    name,
}: {
    img: string;
    name: string;
}) => {
    return (
        <figure><img className="  rounded-md w-44 h-72" alt="" src={img} /></figure>
    )
}

const ReviewCard = ({
    img,
    name,
    username,
    body,
}: {
    img: string;
    name: string;
    username: string;
    body: string;
}) => {
    return (
        <figure
            className={cn(
                "relative h-40 w-36 cursor-pointer overflow-hidden rounded-xl border p-4",
                // light styles
                "border-gray-950/[.1] bg-gray-950/[.01] hover:bg-gray-950/[.05]",
                // dark styles
                "dark:border-gray-50/[.1] dark:bg-gray-50/[.10] dark:hover:bg-gray-50/[.15]",
            )}
        >
            <div className="flex flex-row items-center gap-2">
                <img className="rounded-full" width="32" height="32" alt="" src={img} />
                <div className="flex flex-col">
                    <figcaption className="text-sm font-medium dark:text-white">
                        {name}
                    </figcaption>
                    <p className="text-xs font-medium dark:text-white/40">{username}</p>
                </div>
            </div>
            <blockquote className="mt-2 text-sm">{body}</blockquote>
        </figure>
    );
};


export default function BannerSectionMarqueeVertical() {
    return (
        <div className="relative flex h-full flex-row items-center justify-center overflow-hidden  ">
            {/* <Marquee pauseOnHover vertical className="[--duration:20s]">
                {firstRow.map((review) => (
                    <ReviewCard key={review.username} {...review} />
                ))}
            </Marquee>
            <Marquee reverse pauseOnHover vertical className="[--duration:20s]">
                {secondRow.map((review) => (
                    <ReviewCard key={review.username} {...review} />
                ))}
            </Marquee> */}
            {/* <Marquee pauseOnHover vertical className="[--duration:20s]">
                {secondRow.map((review) => (
                    <ReviewCard key={review.username} {...review} />
                ))}
            </Marquee> */}
            <Marquee pauseOnHover vertical className="[--duration:100s] ">
                {bannerMarqueeImg1.map((review) => (
                    <MarqueeImg key={review.name} {...review} />
                ))}
            </Marquee>
            <Marquee reverse pauseOnHover vertical className="[--duration:100s]">
                {bannerMarqueeImg1.map((review) => (
                    <MarqueeImg key={review.name} {...review} />
                ))}
            </Marquee>
            <Marquee pauseOnHover vertical className="[--duration:100s]">

                {bannerMarqueeImg1.map((review) => (
                    <MarqueeImg key={review.name} {...review} />
                ))}
            </Marquee>


            <div className="pointer-events-none absolute inset-x-0 top-0 h-1/3 bg-gradient-to-b from-white dark:from-background"></div>
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-white dark:from-background"></div>
        </div>
    )
}
